module.exports = __webpack_public_path__ + "img/sort-up.da06d93f.svg";